import { addResourceBundle } from '@egw/i18n'
import en from './src/i18n/locales/en.json'

addResourceBundle('en', 'features-transactions', en)

export * from './src/pages/activity/checking'
export * from './src/pages/activity/savings'
export * from './src/pages/investments'
export * from './src/pages/recent-activity'
export * from './src/pages/recent-investment-activity'
export * from './src/pages/transaction-details'
